// extracted by mini-css-extract-plugin
export default {"item-list":"ItemList__item-list___ee0xP"};